'use client';

import { Provider, useDispatch, useSelector } from 'react-redux';
import { store } from '@/store/store';
import { UiThemeProvider } from '@/providers/UiThemeProvider';
import { UserLocaleProvider } from '@/providers/UserLocaleProvider';
import { ToastProvider } from '@heroui/toast';
import { useState } from 'react';
import { useEffect } from 'react';
import { Provider as RollbarProvider } from '@rollbar/react';
import { rollbarClientConfig } from '@/lib/rollbar-client';
import { SfxProvider } from '@/providers/SfxProvider';
import { ServerNotificationsProvider } from '@/providers/ServerNotificationsProvider';
import { ModalsProvider } from '@/providers/ModalsProvider';
import { StoryLocaleProvider } from '@/providers/StoryLocaleProvider';
import { TutorialAssistant } from '@/components/TutorialAssistant';
import { setIsFlutterWebview } from '@/store/reducers/appSlice';
import { MobileWebviewProvider } from '@/providers/MobileWebviewProvider';

declare global {
  interface Window {
    isFlutterWebview: boolean;
  }
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <RollbarProvider config={rollbarClientConfig}>
      <Provider store={store}>
        <MobileWebviewProvider>
        <ServerNotificationsProvider>          
          <UserLocaleProvider>
            <StoryLocaleProvider>
            <SfxProvider>
              <UiThemeProvider themeProps={{
                attribute: "class",
                defaultTheme: "light",
                enableSystem: true,
                disableTransitionOnChange: true,                
              }}>
                <ToastProvider toastOffset={80} toastProps={{radius: "lg"}} maxVisibleToasts={2} placement="top-center"  />
                <ModalsProvider>
                  {children}
                </ModalsProvider>
                <TutorialAssistant />
              </UiThemeProvider>
            </SfxProvider>
            </StoryLocaleProvider>
          </UserLocaleProvider>
        </ServerNotificationsProvider>
        </MobileWebviewProvider>
      </Provider>
    </RollbarProvider>
  );
} 